import { queryAll, query, fromId } from '../utils/utils.js';

export class Stats {
    root = query('body');

    constructor() {
        
        if (queryAll('section.stat-block').length > 0) { 
            this.equalizeStatItems();

            window.addEventListener('resize', (e) => {
                this.equalizeStatItems();
            });
        }

    }

    equalizeStatItems() {
        queryAll('section.stat-block').forEach((statBlock) => {
            // get the max height of the items in the stat block
            let maxHeight = 0;
            statBlock.querySelectorAll('.item').forEach((item) => {

                const itemHeight = item.getBoundingClientRect().height;
                if (itemHeight > maxHeight) {
                    maxHeight = itemHeight;
                } else {
                    item.style.height = maxHeight + 'px';
                }

            });
        });
    }
}
